<template>
    <div class="wrapper tab-code-help">
        <header>
            <span class="new-headline-md text-centered">Alles klar!<br>Wir kümmern uns um Ihren Freischaltcode.</span>

            <p class="new-text-lg text-centered text-color-default">Wir unterstützen Sie gerne bei der Beantragung Ihres Freischaltcodes. Dafür benötigen wir nur noch ein paar Angaben von Ihnen.</p>
        </header>

        <div class="btn-group">
            <v-button label="Weiter" position="center" @onClick="$emit('answer')"></v-button>
        </div>

        <div class="access-proof">
            <figure class="access-person">
                <img
                    src="imgs/web/img_onboarding_code_help.png"
                    srcset="imgs/web/img_onboarding_code_help.png 1x, imgs/web/img_onboarding_code_help@2x.png 2x"
                    alt=""
                >
            </figure>

            <div class="access-proof-text">
                <strong class="new-text-lg">Wussten Sie...</strong>
                <p class="new-text-md text-color-default">Vitadio kann von Ärzt:innen verschrieben oder bei einer bestätigten Diagnose Typ-2-Diabetes direkt von Ihrer Krankenkasse bezogen werden. Für alle Menschen mit Typ-2-Diabetes ist Vitadio kostenfrei.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {}
</script>
